import Routes from '../routes/routes'
import { buildGetApi } from './helpers'
import buildOptions from './buildApiOptions'

function mapParams ({typeMovement, id}) {
    return {
        typeMovement,
        walletMovementId: id,
    }
}

export default buildGetApi({
    route: Routes.apiSendMovementPaymentReceipt,
    buildResult: () => true,
    mapParams,
    buildOptions,
})
